module.exports = __webpack_public_path__ + "static/media/framerate.eb8a498f.svg";